import { Pillar, isCurrentPillar, isUpcomingPillar } from "../../../types/Pillar"
import PillarCard from "../../molecules/PillarCard/PillarCard"
import { PillarCardSkeleton } from "../../molecules/PillarCard/PillarCard.skeleton"

interface PillarsListProps {
    pillars: Pillar[]
}

const PillarsList = (props: PillarsListProps) => {
    const { pillars } = props

    const sortedPillars = (inputPillars: Pillar[]) => {
        const sortedPillars = [...inputPillars].sort((a, b) => a.order - b.order)
        return sortedPillars.map((pillar) => <PillarCard pillar={pillar} key={pillar.id} />)
    }

    const currentPillars = pillars.filter(isCurrentPillar)
    const upcomingPillars = pillars.filter(isUpcomingPillar)

    const currentPillarCards = sortedPillars(currentPillars)
    const upcomingPillarCards = sortedPillars(upcomingPillars)

    return pillars.length ? (
        <>
            {currentPillarCards}
            {upcomingPillarCards}
        </>
    ) : (
        <>
            <PillarCardSkeleton />
            <PillarCardSkeleton />
        </>
    )
}

export default PillarsList